import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { AppBar } from "../../components/AppShell";
import { useToast } from "../../components/Toast";
import { downloadBlob, request } from "../../lib/api";
import type { CertificateListItem } from "../../lib/types";

export function Certificates() {
  const toast = useToast();
  const { data, isLoading } = useQuery({
    queryKey: ["me", "certificates"],
    queryFn: () => request<CertificateListItem[]>("/me/certificates"),
  });

  async function downloadCert(c: CertificateListItem) {
    try {
      const blob = await downloadBlob(c.download_url.replace(/^\/api/, ""));
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `certificat-${c.certificate_no}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
      toast("Certificat descărcat", "success");
    } catch (err) {
      toast(err instanceof Error ? err.message : "Eroare", "error");
    }
  }

  return (
    <>
      <AppBar crumbs={[{ label: "Tabloul meu", to: "/student/dashboard" }, { label: "Certificate" }]} />
      <div className="content">
        <div className="page-head">
          <div>
            <h1>Certificatele mele</h1>
            <p>Toate certificatele obținute pe platformă.</p>
          </div>
        </div>
        {isLoading ? (
          <div className="card text-muted">Se încarcă…</div>
        ) : !data || data.length === 0 ? (
          <div className="card" style={{ textAlign: "center", padding: 48 }}>
            <i className="fa-solid fa-certificate" style={{ fontSize: "2.4rem", color: "var(--c-primary)", marginBottom: 14 }}></i>
            <h3>Niciun certificat încă</h3>
            <p>Promovează un examen pentru a obține primul tău certificat.</p>
            <Link to="/student/cursuri" className="btn btn-primary">Cursurile mele</Link>
          </div>
        ) : (
          <div className="grid-3">
            {data.map((c) => (
              <article key={c.attempt_id} className="course-card">
                <div className="course-cover" style={{ background: "linear-gradient(135deg,#14a36a,#0a6e47)", alignItems: "center", justifyContent: "center" }}>
                  <i className="fa-solid fa-award" style={{ fontSize: "3rem", color: "#fff", opacity: 0.9 }}></i>
                </div>
                <div className="course-body">
                  <small className="muted">{c.category}</small>
                  <h3 style={{ fontSize: "1rem", margin: "2px 0 6px" }}>{c.course_title}</h3>
                  <div className="course-meta">
                    <span><i className="fa-solid fa-trophy"></i> Notă: {c.score?.toFixed(1) || "—"}</span>
                    <span><i className="fa-regular fa-calendar"></i> {c.issued_at ? new Date(c.issued_at).toLocaleDateString("ro-RO") : "—"}</span>
                  </div>
                  <small className="muted" style={{ display: "block", marginBottom: 10 }}>Cod: {c.certificate_no}</small>
                  <button className="btn btn-primary btn-sm btn-block" onClick={() => downloadCert(c)}>
                    <i className="fa-solid fa-download"></i> Descarcă PDF
                  </button>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
